import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { SessionListItem, SessionListItemAdapter } from "./session-list-item.model";

export interface CourseListItem{
    id:string;
    name:string;
    branchName:string;
    branchLogo:string;
    branchColor:string;
    cover:string;
    series:SeriesListItem[]
}


export interface SeriesListItem {
    id: string;
    name: string;
    courseName:string;
    courseId:string;
    branchName:string;
    branchLogo:string;
    nextSession?:SessionListItem;
    sessionCount:number;
    status:"unresolved"|"failed"|"passed"
  }


  @Injectable({
    providedIn: 'root'
  })

  export class CourseListItemAdapter implements Adapter<CourseListItem> {
    constructor(private sessionListItemAdapter:SessionListItemAdapter){}
  adapt(item: any): CourseListItem {
    return {
      id: item.id,
      name:item.name,
      branchLogo:item.branchLogo??'',
      branchName:item.branchName,
      branchColor:item.branchColor??'',
      cover:item.cover??'',
      series:item.series.map( (series:any) => {        
        return {
        id:series.id,
        name:series.name,
        courseName:series.courseName,
        courseId:series.courseId,
        branchName:series.branchName,
        branchLogo:series.branchLogo??'',
        status:series.status ?? "unresolved",
        nextSession: series.nextSession ? this.sessionListItemAdapter.adapt(series.nextSession): null,
        sessionCount:series.sessionCount
      } as SeriesListItem
    }),
    } as CourseListItem
  }
}


